import {
  Component,
  Input,
  NgZone,
  OnChanges,
  OnInit,
  QueryList,
  signal,
  SimpleChanges,
  ViewChild,
  ViewChildren,
  WritableSignal
} from '@angular/core';
import { ExpandableAreaComponent, SohoTooltipDirective } from 'ids-enterprise-ng';
import { LMFacadeService } from "@app/components";


@Component({
  selector:    'lm-facade-business-class-panel',
  standalone: false,
  templateUrl: './lm-facade-business-class-panel.component.html',
  styleUrl: './lm-facade-business-class-panel.component.scss',
})
export class LMFacadeBusinessClassPanelComponent implements OnInit, OnChanges {

  open = false;
  private defaultButtonIcon = 'chevron-up';

  @Input() panelType: LMFacadeBusinessClassPanel | undefined;
  @Input() businessClassDetail: LMFacadeBusinessClassDetailRequest | undefined;
  label: WritableSignal<string> = signal('');
  data: WritableSignal<Array<LMFacadeComponent>> = signal([]);
  buttonIcon = signal(this.defaultButtonIcon);
  propertiesTooltip = Soho.Locale.translate('Facade_PropertiesDetail');
  @ViewChild(ExpandableAreaComponent) expandableArea: ExpandableAreaComponent | undefined;
  @ViewChildren(SohoTooltipDirective) detailTooltips: QueryList<SohoTooltipDirective> | undefined;

  constructor(
      private ngZone: NgZone,
      protected lmFacadeService: LMFacadeService,
  ) {
    // no-op
  }

  ngOnInit(): void {
    this.initialize();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.panelType || changes.businessClassDetail) {
      this.initialize();
    }
  }

  private initialize() {
     this.initializeLabel();
     this.initializeData();
  }

  private initializeLabel() {
    switch (this.panelType) {
      case 'fields':
        this.label.set(Soho.Locale.translate('Fields'));
        break;
      case "cube-dimensions":
        this.label.set(Soho.Locale.translate('Dimensions'));
        break;
      case 'cube-measures':
        this.label.set(Soho.Locale.translate('Measures'));
        break;
      case 'conditions':
        this.label.set(Soho.Locale.translate('Conditions'));
        break;
      case 'filters':
        this.label.set(Soho.Locale.translate('Filters'));
        break;
      case 'sort-orders':
        this.label.set(Soho.Locale.translate('Sorts'));
        break;
      case 'relations':
        this.label.set(Soho.Locale.translate('Relations'));
        break;
      case 'columnar-dimensions':
        this.label.set(Soho.Locale.translate('Dimensions'));
        break;
      case 'columnar-measures':
        this.label.set(Soho.Locale.translate('Measures'));
        break;
      default:
        this.label.set('Unknown');
    }
  }

  private initializeData() {
    if (!this.businessClassDetail) {
      this.data.set([]);
    } else {
      const moduleTag = this.businessClassDetail.moduleTag;
      const facade = this.businessClassDetail.facade;

      switch (this.panelType) {
        case 'fields':
          this.data.set(this.lmFacadeService.getFacadeFields(moduleTag, facade));
          break;
        case "cube-dimensions":
          this.data.set(this.lmFacadeService.getFacadeCubeDimensions(moduleTag, facade));
          break;
        case 'cube-measures':
          this.data.set(this.lmFacadeService.getFacadeCubeMeasures(moduleTag, facade));
          break;
        case 'conditions':
          this.data.set(this.lmFacadeService.getFacadeConditions(moduleTag, facade));
          break;
        case 'filters':
          this.data.set(this.lmFacadeService.getFacadeFilters(moduleTag, facade));
          break;
        case 'sort-orders':
          this.data.set(this.lmFacadeService.getFacadeSortOrders(moduleTag, facade));
          break;
        case 'relations':
          this.data.set(this.lmFacadeService.getFacadeRelations(moduleTag, facade));
          break;
        case 'columnar-dimensions':
          this.data.set(this.lmFacadeService.getFacadeColumnarDimension(moduleTag, facade));
          break;
        case 'columnar-measures':
          this.data.set(this.lmFacadeService.getFacadeColumnarMeasures(moduleTag, facade));
          break;
        default:
          this.data.set([]);
      }
    }
  }

  // showDetails(facadeComponent: LMFacadeComponent, index: number) {
  //   if (this.detailTooltips) {
  //     const tooltip = this.detailTooltips.get(index);
  //
  //     if (tooltip) {
  //       const html = this.lmFacadeService.buildPropertyHTML(this.panelType, facadeComponent);
  //       tooltip.content = html;
  //       tooltip.maxWidth = 350;
  //       this.ngZone.runOutsideAngular(() => {
  //         setTimeout(() => (tooltip.ngOnChanges(), tooltip.show()));
  //       });
  //     }
  //   }
  // }

  toggleHeaders($event: Event) {
    $event.stopPropagation();
    $event.stopImmediatePropagation();
    this._toggleHeaders();
  }

  private _toggleHeaders() {
    if (this.expandableArea) {
      if (this.open) {
        this.expandableArea.close();
        this.open = false;
      } else {
        this.expandableArea.open();
        this.open = true;
      }
      this.setIcon();
    }
  }

  setIcon() {
    if (this.open) {
      this.buttonIcon.set('chevron-up');
    } else {
      this.buttonIcon.set('chevron-down');
    }
  }
}
